import { useRecoilState } from 'recoil'
import { messageBarOpenState, messageState, errorMessageState } from '~/src/recoil'

/**
 * useMessage
 * Snackbarとset
 */
export const useMessage = () => {
  const [isOpen, setIsOpen] = useRecoilState<boolean>(messageBarOpenState)
  const [successMessage, setMessage] = useRecoilState<string | undefined>(messageState)
  const [errorMessage, setErrorMessage] = useRecoilState<string | undefined>(errorMessageState)

  const handleOpenWithSuccessMessage = (message: string) => {
    setMessage(message)
    setErrorMessage(undefined)
    setIsOpen(true)
  }

  const handleOpenWithErrorMessage = (message: string) => {
    setErrorMessage(message)
    setMessage(undefined)
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
    setTimeout(() => {
      setMessage(undefined)
      setErrorMessage(undefined)
    }, 700)
  }

  return {
    isOpen,
    successMessage,
    errorMessage,
    handleOpenWithSuccessMessage,
    handleOpenWithErrorMessage,
    handleClose,
  }
}
